export const hasPermission = (moduleId, action = "view") => {

  const userData = localStorage.getItem("user");

  if (!userData) {
    return false;
  }

  let user;

  try {
    user = JSON.parse(userData);
  } catch (error) {
    console.error("Invalid user data:", error);
    return false;
  }

  if (
    String(user.role)
      .trim()
      .toLowerCase() === "admin"
  ) {
    return true;
  }

  if (!Array.isArray(user.permissions)) {
    return false;
  }

  const row = user.permissions.find(
    (p) => p.module_id === moduleId
  );

  return row
    ? Number(row[`can_${action}`]) === 1
    : false;
};